import dayjs from '../config/dayjs';
import {
  APPROVED_PAYMENT_API_CODES,
  LIGHTNING_PAYMENT_STATE,
} from '../constants/cache-constants';

const BCI_PAYMENT_CODE = '9';
const STANDARD_LIGHTNING_MAX_DAYS = 15;

const lightningPaymentStateCalculator = (_, { readField }) => {
  const dateIssued = readField('dateIssued');
  const states = readField('uniqueDocumentFinanceState') || [];
  if (!states.length) return LIGHTNING_PAYMENT_STATE.NONE;
  const payedState = states.find((state) => {
    const status = readField('status', state);
    const code = readField('code', status);
    return APPROVED_PAYMENT_API_CODES.includes(code);
  });
  if (!payedState) return LIGHTNING_PAYMENT_STATE.NONE;
  const status = readField('status', payedState);
  const code = readField('code', status);
  if (code === BCI_PAYMENT_CODE) return LIGHTNING_PAYMENT_STATE.BCI;
  if (dayjs().diff(dateIssued, 'days') > STANDARD_LIGHTNING_MAX_DAYS) {
    return LIGHTNING_PAYMENT_STATE.NONE;
  }
  return LIGHTNING_PAYMENT_STATE.STANDARD;
};

export default lightningPaymentStateCalculator;
